import React, { Component } from "react";
import { STAR_EMPTY } from "../../constants";
import Translator from "../../../../../requests/apa/Translator";
import './_styles.scss'
import Asset from "../../../../../requests/apa/Asset";

class EmptyFavorites extends Component {
    render() {
        return(
            <div className="empty-favorites">
                <p className="empty-favorites-header">{Translator.get('eventodeportivo_paises_contenedor_texto_parte1')}</p>
                <p className="empty-favorites-body">
                    {`${Translator.get('eventodeportivo_paises_contenedor_texto_parte2')} `}
                    <img src={Asset.get(STAR_EMPTY)} alt="" />
                    {` ${Translator.get('eventodeportivo_paises_contenedor_texto_parte3')}`}
                </p>
            </div>
        )
    }
}

export default EmptyFavorites


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/EmptyFavorites/index.jsx